import { render, staticRenderFns } from "./registerTips2.vue?vue&type=template&id=4ef10a28&scoped=true"
import script from "./registerTips2.vue?vue&type=script&lang=js"
export * from "./registerTips2.vue?vue&type=script&lang=js"
import style0 from "./registerTips2.vue?vue&type=style&index=0&id=4ef10a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef10a28",
  null
  
)

export default component.exports